import React from 'react';

class YaMap extends React.Component {
  componentDidMount() {
    const { ymaps } = window;

    ymaps.ready(function() {
      var myMap = new ymaps.Map(
        'map',
        {
          center: [57.900348, 40.973921],
          zoom: 6,
        },
        {
          searchControlProvider: 'yandex#search',
        }
      );

      ymaps.borders
        .load('RU', {
          lang: 'ru',
        })
        .then(function(geojson) {
          for (var i = 0; i < geojson.features.length; i++) {
            var geoObject = new ymaps.GeoObject(geojson.features[i]);

            geoObject.properties.set({
              hintContent: Math.random() > 0.5 ? '3G' : '4G',
            });

            geoObject.options.set({
              fillColor: Math.random() > 0.5 ? '#ffc107' : '#3AB54A',
              fillOpacity: 0.3,
            });

            myMap.geoObjects.add(geoObject);
          }

          myMap.behaviors.disable('scrollZoom');

          myMap.controls.remove('trafficControl');
          myMap.controls.remove('geolocationControl');
          myMap.controls.remove('routeButtonControl');
          myMap.controls.remove('typeSelector');
          myMap.controls.remove('rulerControl');
          myMap.controls.remove('searchControl');

          const mapPoints = [
            {
              point: [55.748194, 37.538175],
              title: 'Первый 5G - турнир по киберспорту',
            },
            {
              point: [55.75148, 37.626804],
              title:
                'Телемедицина в 5G: демонстрация удалённого УЗИ и генетического секвенирования',
            },
            {
              point: [55.72381, 37.618732],
              title:
                'Телемедицина в 5G: демонстрация удалённого УЗИ и генетического секвенирования',
            },
            {
              point: [55.773353, 37.605768],
              title: 'Первая в России VR - трансляция футбольного матча в 5G',
            },
            {
              point: [55.710986, 37.542723],
              title: 'Постоянная действующая пилотная зо]на 5G',
            },
            {
              point: [59.93242, 30.302195],
              title: 'Первый международный видеозвонок в российских сетях 5G ',
            },
            {
              point: [59.863389, 29.991008],
              title: 'Открытие первой студенческой 5G - лаборатории',
            },
            {
              point: [55.816632, 49.12615],
              title:
                'Развёртывание пилотной зоны 5G для автономных электробусов «КАМАЗ»',
            },
          ];

          mapPoints.forEach(item => {
            myMap.geoObjects.add(
              new ymaps.Placemark(item.point, {
                balloonContentBody: item.title,
              })
            );
          });
        });
    });
  }

  render() {
    const { height } = this.props;

    return (
      <div id="map" style={{ width: '100%', height: `${height}px` }}></div>
    );
  }
}

export default YaMap;
